/**
 * Labstep
 *
 * @module components/User/Settings/LoginSecurity/ChangePassword
 * @desc Change Password
 */

import {
  fieldUserCurrentPassword,
  fieldUserNewSignupPassword,
  fieldUserNewSignupPasswordConfirmation,
} from 'labstep-web/components/User/Form/fields';
import { ToggleContainer } from 'labstep-web/containers/Toggle';
import { UserChangePasswordContainer } from 'labstep-web/containers/User/ChangePassword';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { Button } from 'labstep-web/core/Button';
import { FormReusable } from 'labstep-web/core/Form/Reusable';
import type React from 'react';
import styles from './styles.module.scss';
import type { IChangePasswordProps } from './types';

const ChangePasswordComponent: React.FC<IChangePasswordProps> = ({
  toggled,
  toggle,
}) => (
  <div id="change-password">
    <div className={styles.options}>
      <ActionComponent
        type="text"
        text="Change password"
        onClick={toggle}
      />
    </div>
    {toggled && (
      <div>
        <div>
          Password needs to be at least 8 characters in length
        </div>
        <UserChangePasswordContainer>
          {({ status, changePassword }) => (
            <FormReusable
              onSubmit={(values) => {
                changePassword(values, { onSuccess: toggle });
              }}
              error={status?.error?.data?.message}
              fields={[
                fieldUserCurrentPassword,
                fieldUserNewSignupPassword,
                fieldUserNewSignupPasswordConfirmation,
              ]}
              submitButton={
                <Button primary loader status={status}>
                  Change Password
                </Button>
              }
            />
          )}
        </UserChangePasswordContainer>
      </div>
    )}
  </div>
);

export const UserSettingsLoginSecurityChangePassword: React.FC<
  any
> = () => (
  <ToggleContainer>
    {({ toggled, toggle }) => (
      <ChangePasswordComponent toggled={toggled} toggle={toggle} />
    )}
  </ToggleContainer>
);
